import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

interface SettingsStoreState {
  sideMenuOpen: boolean;
  menuHidden: boolean;
  breadcrumbsHidden: boolean;
  timezoneDisplay: 'utc' | 'cet';
}

interface SettingsStoreActions {
  setSideMenuOpen: (newStatus: boolean) => void;
  setTimezoneDisplay: (newTimezone: 'utc' | 'cet') => void;
}

type SettingsStore = SettingsStoreState & SettingsStoreActions;

const useSettingsStore = create(
  persist<SettingsStore>(
    (set) => {
      const paramsString = window.location.search;
      const searchParams = new URLSearchParams(paramsString);
      const isCrmMode = searchParams.get('mode') === 'crm';
      return {
        sideMenuOpen: true,
        menuHidden: searchParams.get('menuHidden') === 'true' || isCrmMode,
        breadcrumbsHidden: searchParams.get('breadcrumbsHidden') === 'true' || isCrmMode,
        timezoneDisplay: 'cet',
        setSideMenuOpen: (newStatus: boolean) => {
          set({ sideMenuOpen: newStatus });
        },
        setTimezoneDisplay: (newTimezone: 'utc' | 'cet') => {
          set({ timezoneDisplay: newTimezone });
        },
      };
    },
    {
      name: 'settingsStorage',
      storage: createJSONStorage(() => localStorage),
      // Only persist sideMenuOpen state
      // @ts-expect-error TS2322: Type 'Pick<SettingsStore, "sideMenuOpen">' is not assignable to type 'Partial<SettingsStore> | undefined'.
      partialize: (state) =>
        ({ sideMenuOpen: state.sideMenuOpen }) as Pick<SettingsStore, 'sideMenuOpen'>,
    }
  )
);

export default useSettingsStore;
